var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-uni-view',{staticClass:"u-loading-icon",class:[_vm.vertical && 'u-loading-icon--vertical'],style:([_vm.$u.addStyle(_vm.customStyle)])},[(!_vm.webviewHide)?_c('v-uni-view',{ref:"ani",staticClass:"u-loading-icon__spinner",class:[("u-loading-icon__spinner--" + _vm.mode)],style:({
			color: _vm.color,
			width: _vm.$u.addUnit(_vm.size),
			height: _vm.$u.addUnit(_vm.size),
			borderTopColor: _vm.color,
			borderBottomColor: _vm.otherBorderColor,
			borderLeftColor: _vm.otherBorderColor,
			borderRightColor: _vm.otherBorderColor,
			'animation-duration': (_vm.duration + "ms"),
			'animation-timing-function': _vm.mode === 'semicircle' || _vm.mode === 'circle' ? _vm.timingFunction : ''
		})},[(_vm.mode === 'spinner')?_vm._l((_vm.array12),function(item,index){return _c('v-uni-view',{key:index,staticClass:"u-loading-icon__dot"})}):_vm._e()],2):_vm._e(),(_vm.text)?_c('v-uni-text',{staticClass:"u-loading-icon__text",style:({
			fontSize: _vm.$u.addUnit(_vm.textSize),
			color: _vm.textColor,
		})},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1):_vm._e()}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }